/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect, useCallback, useRef} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {register, resendVerificationEmail, login} from '../core/_requests'
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom'
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'
// import {useAuth} from '../core/Auth'
import axios from 'axios'
import {API_URL} from '../../../../_metronic/global/data'
import {useSnackbar} from 'notistack'
import * as genericServices from '../../../../_metronic/global/genericServices'
import {removeAuth, setAuth} from '../core/AuthHelpers'
import {useDispatch} from 'react-redux'
import RegistrationSuccessDialog from '../../../../_metronic/partials/dialogs/RegistrationSuccessDialog'
import ErrorDialog from '../../../../_metronic/partials/dialogs/ErrorDialog'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Box, CircularProgress} from '@mui/material'
import {usePaystackPayment} from 'react-paystack'
import {PAYPAL_CLIENT_ID, PAYSTACK_PUBLIC_KEY} from '../../../../_metronic/global/data'
import PayPalSubscribeButton from '../../../common/components/PayPalSubscribeButton'
import {checkPermission, DropdownModel} from '../../../../_metronic/helpers/dropdownHelper'

type PermissionOption = {
  value: string
  label: string
}

const initialValues = {
  firstname: '',
  lastname: '',
  email: '',
  password: '',
}

const registrationSchema = Yup.object().shape({
  firstname: Yup.string().required('First name is required'),
  email: Yup.string().email('Wrong email format').required('Email is required'),
  lastname: Yup.string().required('Last name is required'),
  password: Yup.string()
    .min(6, 'Password length should be 6 characters of length')
    .required('Password is required'),
})

const businessSchema = Yup.object().shape({
  name: Yup.string().required('Business name is required'),
  email: Yup.string().email('Wrong email format').required('Business email is required'),
  permissions: Yup.array().min(1, 'At least one permission is required'),
})

export function Registration() {
  const {pathname, search, state} = useLocation()
  const isInvitedUser = pathname.includes('inviteuser') ? true : false
  const {id} = useParams()
  const [isValidLink, setIsValidLink] = useState(false)
  const [showSuccessDialog, setShowSuccessDialog] = useState(false)
  const urlParams = new URLSearchParams(search)
  const hasCreateBusiness = urlParams.has('createbusiness')
  const moduleurl = urlParams.get('createbusiness') || ''
  // const redirect_module_url = process.env.REACT_APP_REDIRECT_MODULE_URL
  // const redirect_module_url = ""
  // const hasRedirectModule = !!redirect_module_url

  const [showVerificationButtons, setShowVerificationButtons] = useState(false)
  const [verificationEmail, setVerificationEmail] = useState('')
  const [lastResendAttempt, setLastResendAttempt] = useState<number>(0)
  const [canResend, setCanResend] = useState(false)
  const [countdown, setCountdown] = useState(0)
  const [currentStep, setCurrentStep] = useState<Step>('registration')
  const [verificationStatus, setVerificationStatus] = useState('')
  const [onboardingError, setOnboardingError] = useState('')
  const [isAutoProcessing, setIsAutoProcessing] = useState(false)
  type Step = 'registration' | 'verification' | 'business' | 'subscription'

  const isOnboarding = pathname.toLowerCase().includes('/auth/registration/onboarding')

  // Helper function to properly decode URL parameters, preserving + in emails
  const getUrlParam = (paramName: string): string => {
    const param = urlParams.get(paramName)
    if (!param) return ''
    // For email parameters, we need to preserve + characters
    // URLSearchParams converts + to space, so we need to decode the raw search string
    if (paramName === 'user-email' || paramName === 'business-email') {
      // Get the raw parameter value from the search string
      const match = search.match(new RegExp(`[?&]${paramName}=([^&]*)`))
      if (match) {
        return decodeURIComponent(match[1].replace(/\+/g, '%2B'))
      }
    }
    return param
  }

  const urlFirstName = urlParams.get('first-name') || ''
  const urlLastName = urlParams.get('last-name') || ''
  const urlEmail = getUrlParam('user-email')
  const urlBusinessName = urlParams.get('business-name') || ''
  const urlBusinessEmail = getUrlParam('business-email')
  const urlSubscriptionType = urlParams.get('subscription-type') || ''
  const urlTotalUsers = urlParams.get('total-users') || ''
  const urlSubscriptionId = urlParams.get('subscription-id') || ''
  const hasOnboardingParams = !!(urlFirstName || urlLastName || urlEmail)
  const {enqueueSnackbar} = useSnackbar()
  const navigate = useNavigate()
  const [checkVerificationLoading, setCheckVerificationLoading] = useState(false)
  const [resendEmailLoading, setResendEmailLoading] = useState(false)
  const [businessLoading, setBusinessLoading] = useState(false)
  const [businessKey, setBusinessKey] = useState<string>('')
  const [businessId, setBusinessId] = useState<string>('')
  const [subscriptionLoading, setSubscriptionLoading] = useState(false)
  const [subscriptionError, setSubscriptionError] = useState('')
  const [showPaymentOptions, setShowPaymentOptions] = useState(false)
  const [isProcessingSubscription, setIsProcessingSubscription] = useState(false)
  const hasProcessedSubscriptionRef = useRef(false)

  const normalizeSubscriptionType = (type: string): string => {
    if (!type) return 'STARTER'
    const upperType = type.toUpperCase().trim()
    // Check if it matches valid subscription types
    if (['STARTER', 'STANDARD', 'PREMIUM'].includes(upperType)) {
      return upperType
    }
    // If not clear, default to STARTER
    return 'STARTER'
  }

  const [businessData, setBusinessData] = useState({
    name: urlBusinessName || '',
    email: urlBusinessEmail || '',
    permissions: [] as string[],
  })
  const [businessErrors, setBusinessErrors] = useState({
    name: '',
    permissions: '',
  })
  const [businessCreationError, setBusinessCreationError] = useState('')
  // const {saveAuth} = useAuth()
  const [permissionOptions, setPermissionOptions] = useState<PermissionOption[]>(checkPermission)
  const [selectedPermission, setSelectedPermission] = useState('')

  // Subscription state
  const [subscriptionData, setSubscriptionData] = useState({
    subscriptionType: '',
    noOfUsers: 1,
    amount: 0,
    discount: 0,
  })
  const [isPaypal, setIsPaypal] = useState(false)
  const [paypalPlanId, setPaypalPlanId] = useState('')

  // Paystack configuration
  const [paystackConfig, setPaystackConfig] = useState({
    email: verificationEmail || '',
    plan: '',
    publicKey: PAYSTACK_PUBLIC_KEY || '',
    initialize_payment: false,
    amount: 0,
    label: '',
    firstname: '',
    lastname: '',
  })
  const initializePayment = usePaystackPayment(paystackConfig)

  const dispatch = useDispatch()

  const VerifyLink = useCallback(async () => {
    if (!isInvitedUser) {
      const response = await genericServices.get(`users/is_valid_link/${id}`)
      if (response.status === 200) {
        setIsValidLink(true)
      } else {
        let message = response?.data?.message ?? 'Something went wrong'
        if (id) sessionStorage.setItem(`invite_link_error_${id}`, message)
        enqueueSnackbar(message, {variant: 'error'})
      }
    }
  }, [id, enqueueSnackbar, isInvitedUser])

  useEffect(() => {
    id && VerifyLink()
  }, [id, VerifyLink])

  // Save module URL in localStorage when registration starts
  useEffect(() => {
    if (moduleurl) {
      localStorage.setItem('registration_module_url', moduleurl)
    }
  }, [moduleurl])

  // Handle payment failure redirect - return to subscription step
  useEffect(() => {
    if ((state as any)?.returnToStep === 'subscription' && (state as any)?.paymentFailed) {
      // Check if we have the necessary data in localStorage to resume
      const businessData = localStorage.getItem('registration_business_data')
      const authToken =
        localStorage.getItem('idToken') || localStorage.getItem('registration_auth_token')

      if (businessData && authToken) {
        setCurrentStep('subscription')
        setSubscriptionError(
          'Previous payment failed. Please try again with a different payment method.'
        )
        enqueueSnackbar('Payment failed. Please select a subscription and try again.', {
          variant: 'error',
        })
      } else {
        enqueueSnackbar('Session expired. Please start registration again.', {variant: 'error'})
        navigate(`/auth/login`)
      }
    }
  }, [state, enqueueSnackbar, navigate, moduleurl])

  const handleBusinessEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBusinessData({...businessData, email: e.target.value})
  }

  useEffect(() => {
    if (!canResend && lastResendAttempt > 0) {
      const interval = setInterval(() => {
        const timeLeft = Math.ceil((60000 - (Date.now() - lastResendAttempt)) / 1000)

        if (timeLeft <= 0) {
          setCanResend(true)
          setCountdown(0)
          clearInterval(interval)
        } else {
          setCountdown(timeLeft)
        }
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [canResend, lastResendAttempt])

  const formik = useFormik({
    initialValues: {
      firstname: urlFirstName,
      lastname: urlLastName,
      email: urlEmail,
      password: '',
    },
    validationSchema: registrationSchema,
    enableReinitialize: true,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setStatus()
      setSubmitting(true)
      try {
        const {data: auth} = await register(values.email, values.password)
        setAuth(auth, dispatch)

        // Step 1: Store module URL in localStorage if present
        if (moduleurl) {
          localStorage.setItem('registration_module_url', moduleurl)
        }

        let payload: any = {
          first_name: values.firstname,
          last_name: values.lastname,
        }

        const res = await axios.post(`${API_URL}users`, payload)
        // removeAuth(dispatch)
        if (res.status === 201) {
          // Step 2: Verify and store auth token in localStorage after account creation
          const authToken = auth?.api_token
          if (authToken) {
            const authData = {
              ...auth,
              api_token: authToken,
              email: values.email,
            }
            localStorage.setItem('registration_auth_token', JSON.stringify(authData))
          }

          // Modified: Check if redirect module exists
          if (hasCreateBusiness) {
            setVerificationEmail(values.email)
            setCurrentStep('verification') // Navigate to verification step
          } else {
            setShowSuccessDialog(true) // Show success dialog directly
          }
          setSubmitting(false)
        }
      } catch (error: any) {
        error.message === 'Firebase: Error (auth/email-already-in-use).'
          ? setStatus('Email Already Exist.')
          : setStatus(error.message)
        removeAuth(dispatch)
        setSubmitting(false)
      }
    },
  })

  const handleCheckVerification = async () => {
    setCheckVerificationLoading(true)
    try {
      await login(verificationEmail, formik.values.password)

      // For onboarding, auto-process business and subscription
      if (hasOnboardingParams && isOnboarding) {
        setIsAutoProcessing(true)

        // Set business data from URL
        setBusinessData({
          name: urlBusinessName || '',
          email: urlBusinessEmail || '',
          permissions: [checkPermission[0]?.value || ''] as string[],
        })

        // Auto-create business
        try {
          const businessPayload = {
            name: urlBusinessName || '',
            email: urlBusinessEmail || '',
            check_permission: checkPermission[0]?.value || '',
          }

          const businessResponse = await genericServices.post('business', businessPayload)

          if (businessResponse.status === 200 || businessResponse.status === 201) {
            const businessId = businessResponse.data?.current_business
            const businessKey = businessResponse.data?.business_key

            // Store business data
            if (businessKey || businessId) {
              const authData =
                localStorage.getItem('idToken') || localStorage.getItem('registration_auth_token')
              if (authData) {
                try {
                  const parsedAuth = JSON.parse(authData)
                  if (businessKey) parsedAuth.business_key = businessKey
                  if (businessId) parsedAuth.business_id = businessId
                  localStorage.setItem('idToken', JSON.stringify(parsedAuth))
                } catch (error) {
                  const newAuth = {
                    api_token: authData,
                    business_key: businessKey,
                    business_id: businessId,
                  }
                  localStorage.setItem('idToken', JSON.stringify(newAuth))
                }
              }
            }

            // Auto-process subscription
            if (urlSubscriptionType && subscriptionData.subscriptionType) {
              await processSubscription()
            } else {
              // If no subscription in URL, redirect to module
              if (moduleurl) {
                const authData = localStorage.getItem('idToken')
                let token = ''
                if (authData) {
                  try {
                    const parsedAuth = JSON.parse(authData)
                    token = parsedAuth.api_token || parsedAuth.token || parsedAuth.accessToken || ''
                  } catch (error) {
                    token = authData
                  }
                }
                const redirectUrl = new URL(moduleurl)
                if (token) {
                  redirectUrl.searchParams.append('token', token)
                }
                redirectUrl.searchParams.append('email', verificationEmail)
                window.location.href = redirectUrl.toString()
              }
            }
          } else {
            const errorMessage = businessResponse.data?.message || 'Failed to create business'
            setOnboardingError(errorMessage)
            setIsAutoProcessing(false)
          }
        } catch (error: any) {
          const errorMessage = error.response?.data?.message || 'Failed to create business'
          setOnboardingError(errorMessage)
          setIsAutoProcessing(false)
        }
      } else {
        // Non-onboarding flow - show business step
        setBusinessData({
          name: urlBusinessName || '',
          email: urlBusinessEmail || '',
          permissions: [checkPermission[0]?.value || ''] as string[],
        })
        setCurrentStep('business')
      }
    } catch (error: any) {
      if (error.message.includes('verify your email')) {
        setVerificationStatus('Email not verified yet. Please check your inbox.')
      } else {
        setVerificationStatus(error.message)
      }
    }
    setCheckVerificationLoading(false)
  }

  const handleResendVerification = async () => {
    const now = Date.now()
    const cooldownPeriod = 30000

    if (now - lastResendAttempt < cooldownPeriod) {
      const timeLeft = Math.ceil((cooldownPeriod - (now - lastResendAttempt)) / 1000)
      setVerificationStatus(`Please wait ${timeLeft} seconds before resending verification email.`)
      return
    }

    setResendEmailLoading(true)
    try {
      const result = await resendVerificationEmail(verificationEmail, formik.values.password)
      setLastResendAttempt(Date.now())
      setCanResend(false)
      setCountdown(30)
      setVerificationStatus('Verification email sent successfully!')
    } catch (error: any) {
      setLastResendAttempt(Date.now())
      if (error.message.includes('too-many-requests')) {
        setVerificationStatus('Please wait a few minutes before resending the email.')
      } else {
        setVerificationStatus(
          error.message || 'Failed to send verification email. Please try again.'
        )
      }
    }
    setResendEmailLoading(false)
  }
  const validateBusinessFields = () => {
    const errors = {
      name: '',
      permissions: '',
    }

    if (!businessData.name.trim()) {
      errors.name = 'Business name is required'
    }

    if (businessData.permissions.length === 0) {
      errors.permissions = 'At least one permission is required'
    }

    setBusinessErrors(errors)
    return !errors.name && !errors.permissions
  }

  const handleCreateBusiness = async () => {
    // Validate business fields
    if (!validateBusinessFields()) {
      return
    }

    setBusinessLoading(true)
    try {
      const businessPayload = {
        name: businessData.name,
        email: businessData.email,
        check_permission: businessData.permissions[0],
      }

      const response = await genericServices.post('business', businessPayload)

      // Check if the response is successful (status 200 or 201)
      if (response.status === 200 || response.status === 201) {
        // Step 3: Check and verify business_id and business_key from response
        const businessId = response.data?.current_business
        const businessKey = response.data?.business_key

        if (!businessId) {
          enqueueSnackbar('Business creation succeeded but business ID is missing', {
            variant: 'warning',
          })
        }

        if (!businessKey) {
          enqueueSnackbar('Business creation succeeded but business key is missing', {
            variant: 'warning',
          })
        }

        // Store the business_key and business_id from the response for subscription API
        if (businessKey || businessId) {
          // Store business_key in component state
          if (businessKey) {
            setBusinessKey(businessKey)
          }

          // Store business_id in component state
          if (businessId) {
            setBusinessId(businessId)
          }

          // Step 3: Store verified business_id and business_key in localStorage
          const currentAuth = localStorage.getItem('idToken')
          const registrationAuth = localStorage.getItem('registration_auth_token')

          // Try to get auth from either source
          let authToUpdate = currentAuth || registrationAuth

          if (authToUpdate) {
            try {
              const parsedAuth = JSON.parse(authToUpdate)
              if (businessKey) {
                parsedAuth.business_key = businessKey
              }
              if (businessId) {
                parsedAuth.business_id = businessId
              }
              localStorage.setItem('idToken', JSON.stringify(parsedAuth))
              localStorage.setItem(
                'registration_business_data',
                JSON.stringify({
                  business_key: businessKey,
                  business_id: businessId,
                  business_name: businessData.name,
                  business_email: businessData.email,
                })
              )
            } catch (error) {
              // If parsing fails, create new auth object
              const newAuth = {
                api_token: authToUpdate,
                business_key: businessKey,
                business_id: businessId,
              }
              localStorage.setItem('idToken', JSON.stringify(newAuth))
              localStorage.setItem(
                'registration_business_data',
                JSON.stringify({
                  business_key: businessKey,
                  business_id: businessId,
                  business_name: businessData.name,
                  business_email: businessData.email,
                })
              )
            }
          } else {
            // Create new auth object with business key and business_id
            const newAuth = {
              business_key: businessKey,
              business_id: businessId,
            }
            localStorage.setItem('idToken', JSON.stringify(newAuth))
            localStorage.setItem(
              'registration_business_data',
              JSON.stringify({
                business_key: businessKey,
                business_id: businessId,
                business_name: businessData.name,
                business_email: businessData.email,
              })
            )
          }
        } else {
          enqueueSnackbar('Business creation succeeded but data is incomplete', {
            variant: 'warning',
          })
        }

        // Proceed to subscription step only if business creation was successful
        setCurrentStep('subscription')
        // If subscription type is in URL, payment options will be auto-shown via useEffect
      } else {
        // Handle non-successful response (400, 500, etc.)
        const errorMessage =
          response.data?.message || 'Failed to create business. Please try again.'
        setBusinessCreationError(errorMessage)
        enqueueSnackbar(errorMessage, {variant: 'error'})
      }
    } catch (error: any) {
      const errorMessage = error.message || 'Failed to create business'
      setBusinessCreationError(errorMessage)
      enqueueSnackbar(errorMessage, {variant: 'error'})
    }
    setBusinessLoading(false)
  }
  const handlePermissionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value
    setSelectedPermission(value)
    setBusinessData({
      ...businessData,
      permissions: [value],
    })
    // Clear permission error when user selects something
    if (businessErrors.permissions) {
      setBusinessErrors({...businessErrors, permissions: ''})
    }
    // Clear business creation error when user selects permission
    if (businessCreationError) {
      setBusinessCreationError('')
    }
  }
  const handleBusinessNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBusinessData({...businessData, name: e.target.value})
    // Clear name error when user starts typing
    if (businessErrors.name) {
      setBusinessErrors({...businessErrors, name: ''})
    }
    // Clear business creation error when user starts typing
    if (businessCreationError) {
      setBusinessCreationError('')
    }
  }

  // Subscription handlers
  const handleSubscriptionTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const subscriptionType = e.target.value
    setSubscriptionData({...subscriptionData, subscriptionType})
    setShowPaymentOptions(false)
    setSubscriptionError('') // Clear any previous errors when changing subscription type

    // Calculate amount based on subscription type and number of users
    let baseAmount = 0
    if (subscriptionType === 'STARTER' || subscriptionType === 'STANDARD') {
      baseAmount = subscriptionData.noOfUsers * 20
    } else if (subscriptionType === 'PREMIUM') {
      baseAmount = subscriptionData.noOfUsers * 50
    }
    setSubscriptionData({...subscriptionData, subscriptionType, amount: baseAmount})
  }

  const handleUserCountChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const noOfUsers = parseInt(e.target.value)
    setSubscriptionData({...subscriptionData, noOfUsers})
    setSubscriptionError('') // Clear any previous errors when changing user count

    // Recalculate amount
    let baseAmount = 0
    if (
      subscriptionData.subscriptionType === 'STARTER' ||
      subscriptionData.subscriptionType === 'STANDARD'
    ) {
      baseAmount = noOfUsers * 20
    } else if (subscriptionData.subscriptionType === 'PREMIUM') {
      baseAmount = noOfUsers * 50
    }
    setSubscriptionData({...subscriptionData, noOfUsers, amount: baseAmount})
  }
  const processSubscription = async () => {
    if (!subscriptionData.subscriptionType || !subscriptionData.noOfUsers) {
      setSubscriptionError('Subscription data is missing')
      return
    }

    setIsProcessingSubscription(true)
    setSubscriptionError('')

    try {
      const authData = localStorage.getItem('idToken')
      let token = ''
      let businessKeyFromStorage = ''

      if (authData) {
        try {
          const parsedAuth = JSON.parse(authData)
          token = parsedAuth.api_token || parsedAuth.token || parsedAuth.accessToken || ''
          businessKeyFromStorage = parsedAuth.business_key || ''
        } catch (error) {
          token = authData
        }
      }

      const headers: any = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }

      if (businessKeyFromStorage) {
        headers['BusinessKey'] = businessKeyFromStorage
      }

      const payload: any = {
        noOfUsers: subscriptionData.noOfUsers,
        onboardingUrl: moduleurl,
        type: subscriptionData.subscriptionType,
        subscriptionId: urlSubscriptionId || '',
      }

      const customAxios = axios.create({
        baseURL: API_URL,
        headers: headers,
      })

      const response = await customAxios.post('subscription/onboarding', payload)

      // Statically keep 201 as response for onboarding
      if (response.status === 201) {
        // Backend handles payment - redirect to module URL
        if (moduleurl) {
          const authData = localStorage.getItem('idToken')
          let token = ''
          if (authData) {
            try {
              const parsedAuth = JSON.parse(authData)
              token = parsedAuth.api_token || parsedAuth.token || parsedAuth.accessToken || ''
            } catch (error) {
              token = authData
            }
          }
          const redirectUrl = new URL(moduleurl)
          if (token) {
            redirectUrl.searchParams.append('token', token)
          }
          redirectUrl.searchParams.append('email', verificationEmail)
          window.location.href = redirectUrl.toString()
        }
      } else {
        const message =
          response.data?.message?.message ?? response.data?.message ?? 'Something went wrong'
        setSubscriptionError(message)
      }
    } catch (error: any) {
      if (
        (error.response?.status === 400 || error.response?.status === 422) &&
        hasOnboardingParams &&
        isOnboarding
      ) {
        // Handle 400 error in onboarding flow
        const message =
          error.response?.data?.message?.message ??
          error.response?.data?.message ??
          'Invalid subscription data. Please check your selections.'
        setOnboardingError(message)
      } else {
        const message =
          error.response?.data?.message?.message ??
          error.response?.data?.message ??
          'Failed to process subscription'
        setSubscriptionError(message)
      }
    } finally {
      setIsProcessingSubscription(false)
    }
  }
  const proceedToPayment = () => {
    if (!subscriptionData.subscriptionType) {
      setSubscriptionError('Please select a subscription type')
      return
    }

    // Clear any previous errors when proceeding to payment
    setSubscriptionError('')
    setShowPaymentOptions(true)
  }

  const submitSubscription = async (paymentGateway: 'STRIPE' | 'PAYPAL' | 'PAYSTACK') => {
    setSubscriptionLoading(true)
    setSubscriptionError('')

    try {
      // Use axios directly with proper headers for subscription
      const authData = localStorage.getItem('idToken')
      let token = ''
      let businessKeyFromStorage = ''
      let businessIdFromStorage = ''

      if (authData) {
        try {
          const parsedAuth = JSON.parse(authData)
          token = parsedAuth.api_token || parsedAuth.token || parsedAuth.accessToken || ''
          businessKeyFromStorage = parsedAuth.business_key || ''
          businessIdFromStorage = parsedAuth.business_id || ''
        } catch (error) {
          token = authData
        }
      }

      // Also try to get business key and business_id from auth state if not found in token
      if (!businessKeyFromStorage || !businessIdFromStorage) {
        const authState = localStorage.getItem('auth')
        if (authState) {
          try {
            const parsedAuthState = JSON.parse(authState)
            businessKeyFromStorage = businessKeyFromStorage || parsedAuthState.business_key || ''
            businessIdFromStorage = businessIdFromStorage || parsedAuthState.business_id || ''
          } catch (error) {
            // Ignore parsing error
          }
        }
      }

      // Use component state as fallback if not found in storage
      const finalBusinessKey = businessKeyFromStorage || businessKey
      const finalBusinessId = businessIdFromStorage || businessId

      // Get current origin for redirect URLs
      const currentOrigin = window.location.origin

      const payload: any = {
        no_of_users: subscriptionData.noOfUsers,
        is_business_subscription: true,
        amount:
          subscriptionData.amount - subscriptionData.discount >= 0
            ? subscriptionData.amount - subscriptionData.discount
            : 0,
        total_amount: subscriptionData.amount,
        type: subscriptionData.subscriptionType,
        payment_gateway: paymentGateway,
        onboardingUrl: moduleurl,
      }

      const headers: any = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }

      // Add business_key (JWT token) as BusinessKey header - this is required for subscription API
      if (finalBusinessKey) {
        headers['BusinessKey'] = finalBusinessKey
      } else {
        console.warn('No business_key found for subscription API')
      }

      // Create a custom axios instance without interceptors to prevent automatic redirects
      const customAxios = axios.create({
        baseURL: API_URL,
        headers: headers,
      })

      const response = await customAxios.post('subscription', payload)
      //  const response = { status: 201, data: {"message": "Subscription created successfully from onboarding"} }

      if (response.status === 201) {
        // Backend handles payment processing, no frontend action needed
        // Backend will redirect or handle payment flow
      } else {
        const message = response.data.message ? response.data.message : 'Something went wrong'
        setSubscriptionError(message)
      }
    } catch (error: any) {
      // Handle different types of errors more specifically
      if (error.response) {
        // Server responded with error status
        if (error.response.status === 401) {
          setSubscriptionError('Authentication failed. Please try again.')
        } else if (error.response.status === 403) {
          setSubscriptionError(
            'Access denied. You may not have permission to create subscriptions.'
          )
        } else if (error.response.status === 400) {
          if (hasOnboardingParams && isOnboarding) {
            // Handle 400 error in onboarding flow
            const message =
              error.response.data?.message?.message ??
              error.response.data?.message ??
              'Invalid subscription data. Please check your selections.'
            setOnboardingError(message)
          } else {
            setSubscriptionError('Invalid subscription data. Please check your selections.')
          }
        } else if (error.response.status === 500) {
          console.error('500 Internal Server Error details:', error.response.data)
          const message =
            error.response.data?.message?.message ??
            error.response.data?.message ??
            'Internal server error. Please try again later.'
          setSubscriptionError(message)
        } else {
          const message =
            error.response.data?.message?.message ??
            error.response.data?.message ??
            'Failed to process subscription'
          setSubscriptionError(message)
        }
      } else if (error.request) {
        // Network error
        setSubscriptionError('Network error. Please check your connection and try again.')
      } else {
        // Other error
        setSubscriptionError('Failed to process subscription. Please try again.')
      }
    }

    setSubscriptionLoading(false)
  }

  // Helper function to redirect to module URL after successful payment
  const redirectToModuleUrl = () => {
    if (moduleurl) {
      const authData = localStorage.getItem('idToken')
      let token = ''

      if (authData) {
        try {
          const parsedAuth = JSON.parse(authData)
          token = parsedAuth.api_token || parsedAuth.token || parsedAuth.accessToken || ''
        } catch (error) {
          token = authData
        }
      }

      const redirectUrl = new URL(moduleurl)
      if (token) {
        redirectUrl.searchParams.append('token', token)
      }
      redirectUrl.searchParams.append('email', verificationEmail)

      window.location.href = redirectUrl.toString()
    } else {
      setShowSuccessDialog(true)
    }
  }

  const onPaystackPaymentSuccess = (response: any) => {
    // Handle successful payment
    if (response.status === 'success') {
      // Redirect to onboarding payment success page
      window.location.href = '/auth/registration/onboarding/payment-success'
    }
  }

  const onPaystackPaymentCancelled = () => {
    // Redirect to onboarding payment failed page
    window.location.href = '/auth/registration/onboarding/payment-failed'
  }

  const onPaypalPaymentApproval = () => {
    // Redirect to onboarding payment success page
    window.location.href = '/auth/registration/onboarding/payment-success'
  }

  // Auto-trigger Paystack payment when config is ready
  useEffect(() => {
    if (paystackConfig.initialize_payment) {
      const button = document.getElementById('initialize_paystack_payment') as HTMLButtonElement
      if (button) {
        button.click()
      }
    }
  }, [paystackConfig])

  useEffect(() => {
    PasswordMeterComponent.bootstrap()
  }, [])

  // Stripe payment success is now handled by PaymentSuccessRedirect component

  const handleProceedToLogin = () => {
    setShowSuccessDialog(false)
    if (isInvitedUser) {
      navigate(`../login/inviteuser/${id}`)
    } else if (isValidLink) {
      navigate(`../invite/${id}`)
    } else {
      navigate('../login')
    }
  }

  useEffect(() => {
    if (hasOnboardingParams && isOnboarding) {
      formik.setFieldValue('firstname', urlFirstName)
      formik.setFieldValue('lastname', urlLastName)
      formik.setFieldValue('email', urlEmail)
      setTimeout(() => {
        formik.validateForm().then(() => {
          // Touch the fields so formik recognizes them as valid
          formik.setFieldTouched('firstname', true)
          formik.setFieldTouched('lastname', true)
          formik.setFieldTouched('email', true)
        })
      }, 0)
    }
  }, [urlFirstName, urlLastName, urlEmail, hasOnboardingParams, isOnboarding])

  // Update business data when URL parameters are available
  useEffect(() => {
    if (urlBusinessName || urlBusinessEmail) {
      setBusinessData((prev) => ({
        ...prev,
        name: urlBusinessName || prev.name,
        email: urlBusinessEmail || prev.email,
      }))
    }
  }, [urlBusinessName, urlBusinessEmail])

  useEffect(() => {
    if (hasOnboardingParams && isOnboarding && urlSubscriptionType) {
      const normalizedType = normalizeSubscriptionType(urlSubscriptionType)
      const numUsers = parseInt(urlTotalUsers) || 1 // Default to 1 if not provided

      // Calculate amount based on subscription type
      let baseAmount = 0
      if (normalizedType === 'STARTER' || normalizedType === 'STANDARD') {
        baseAmount = numUsers * 20
      } else if (normalizedType === 'PREMIUM') {
        baseAmount = numUsers * 50
      }

      setSubscriptionData({
        subscriptionType: normalizedType,
        noOfUsers: numUsers,
        amount: baseAmount,
        discount: 0,
      })
    }
  }, [urlSubscriptionType, urlTotalUsers, hasOnboardingParams, isOnboarding])

  // Auto-show payment options when subscription is auto-selected from URL
  useEffect(() => {
    if (
      hasOnboardingParams &&
      isOnboarding &&
      urlSubscriptionType &&
      subscriptionData.subscriptionType &&
      currentStep === 'subscription' &&
      !showPaymentOptions &&
      !isProcessingSubscription &&
      !hasProcessedSubscriptionRef.current
    ) {
      hasProcessedSubscriptionRef.current = true
      // Process subscription automatically
      processSubscription()
    }
  }, [
    hasOnboardingParams,
    isOnboarding,
    urlSubscriptionType,
    subscriptionData.subscriptionType,
    subscriptionData.noOfUsers,
    currentStep,
    showPaymentOptions,
    isProcessingSubscription,
  ])

  return (
    <>
      <div className='w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto'>
        {currentStep === 'registration' ? (
          <form
            className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
            noValidate
            id='kt_login_signup_form'
            onSubmit={formik.handleSubmit}
          >
            {/* begin::Heading */}
            <div className='mb-10 text-center'>
              {/* begin::Title */}
              <h1 className='text-dark mb-3'>Create an Account</h1>
              {/* end::Title */}

              {/* begin::Link */}
              {!moduleurl && (
                <div className='text-gray-400 fw-bold fs-4'>
                  Already have an account?
                  <Link
                    to={
                      isInvitedUser
                        ? `/auth/login/inviteuser/${id}`
                        : id
                        ? `/auth/invite/${id}`
                        : '/auth/login'
                    }
                    className='link-primary fw-bolder'
                    style={{marginLeft: '5px'}}
                  >
                    Sign in
                  </Link>
                </div>
              )}
              {/* end::Link */}
            </div>
            {/* end::Heading */}

            {formik.status && (
              <div className='mb-lg-15 alert alert-danger'>
                <div className='alert-text font-weight-bold'>{formik.status}</div>
              </div>
            )}

            {/* begin::Form group Firstname */}
            <div className='row fv-row mb-7'>
              <div className='col-xl-6'>
                <label className='form-label fw-bolder text-dark fs-6'>First name</label>
                <input
                  placeholder='First name'
                  type='text'
                  autoComplete='off'
                  {...formik.getFieldProps('firstname')}
                  disabled={hasOnboardingParams && isOnboarding}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.firstname && formik.errors.firstname,
                    },
                    {
                      'is-valid': formik.touched.firstname && !formik.errors.firstname,
                    }
                  )}
                />
                {formik.touched.firstname && formik.errors.firstname && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{formik.errors.firstname}</span>
                    </div>
                  </div>
                )}
              </div>
              <div className='col-xl-6'>
                {/* begin::Form group Lastname */}
                <div className='fv-row'>
                  <label className='form-label fw-bolder text-dark fs-6'>Last name</label>
                  <input
                    placeholder='Last name'
                    type='text'
                    autoComplete='off'
                    {...formik.getFieldProps('lastname')}
                    disabled={hasOnboardingParams && isOnboarding}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid': formik.touched.lastname && formik.errors.lastname,
                      },
                      {
                        'is-valid': formik.touched.lastname && !formik.errors.lastname,
                      }
                    )}
                  />
                  {formik.touched.lastname && formik.errors.lastname && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.lastname}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
              </div>
            </div>
            {/* end::Form group */}

            {/* begin::Form group Email */}
            <div className='fv-row mb-7'>
              <label className='form-label fw-bolder text-dark fs-6'>Email</label>
              <input
                placeholder='Email'
                type='email'
                autoComplete='off'
                {...formik.getFieldProps('email')}
                disabled={hasOnboardingParams && isOnboarding}
                className={clsx(
                  'form-control form-control-lg form-control-solid',
                  {'is-invalid': formik.touched.email && formik.errors.email},
                  {
                    'is-valid': formik.touched.email && !formik.errors.email,
                  }
                )}
              />
              {formik.touched.email && formik.errors.email && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span role='alert'>{formik.errors.email}</span>
                  </div>
                </div>
              )}
            </div>
            {/* end::Form group */}

            {/* begin::Form group Password */}
            <div className='mb-10 fv-row' data-kt-password-meter='true'>
              <div className='mb-1'>
                <label className='form-label fw-bolder text-dark fs-6'>Password</label>
                <div className='position-relative mb-3'>
                  <input
                    type='password'
                    placeholder='Password'
                    autoComplete='off'
                    {...formik.getFieldProps('password')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {
                        'is-invalid': formik.touched.password && formik.errors.password,
                      },
                      {
                        'is-valid': formik.touched.password && !formik.errors.password,
                      }
                    )}
                  />
                  {formik.touched.password && formik.errors.password && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.password}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* begin::Meter */}
                <div
                  className='d-flex align-items-center mb-3'
                  data-kt-password-meter-control='highlight'
                >
                  <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
                  <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
                  <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
                  <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
                </div>
                {/* end::Meter */}
              </div>
              <div className='text-muted'>
                Use 8 or more characters with a mix of letters, numbers & symbols.
              </div>
            </div>
            {/* end::Form group */}

            {/* begin::Form group */}
            <div className='text-center'>
              <button
                type='submit'
                id='kt_sign_up_submit'
                className='btn btn-sm btn-primary w-100 mb-5'
                disabled={formik.isSubmitting || !formik.isValid}
              >
                {!formik.isSubmitting && <span className='indicator-label'>Next</span>}
                {formik.isSubmitting && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
            {/* end::Form group */}
          </form>
        ) : currentStep === 'verification' ? (
          /* Verification Step Content */
          <div className='text-center'>
            {isAutoProcessing ? (
              <>
                <CircularProgress size={40} />
                <div className='mt-3'>Processing your onboarding...</div>
                <div className='text-muted mt-2'>Creating business and setting up subscription</div>
              </>
            ) : (
              <>
                <h1 className='text-dark mb-3'>Verify Your Email</h1>
                <p className='text-gray-600 mb-10'>
                  We've sent a verification email to <strong>{verificationEmail}</strong>. Please
                  check your inbox and verify your email address.
                </p>

                {verificationStatus && (
                  <div
                    className={`mb-10 alert ${
                      verificationStatus.includes('successfully') ? 'alert-success' : 'alert-danger'
                    }`}
                  >
                    <div className='alert-text font-weight-bold'>{verificationStatus}</div>
                  </div>
                )}
                <div className='d-flex gap-3 justify-content-center'>
                  <button
                    type='button'
                    className='btn btn-sm btn-primary'
                    onClick={handleCheckVerification}
                    disabled={checkVerificationLoading || resendEmailLoading || isAutoProcessing}
                  >
                    {checkVerificationLoading ? 'Checking...' : 'Check Verification'}
                  </button>
                  <button
                    type='button'
                    className='btn btn-sm btn-outline-primary'
                    onClick={handleResendVerification}
                    disabled={
                      resendEmailLoading ||
                      checkVerificationLoading ||
                      isAutoProcessing ||
                      (!canResend && Date.now() - lastResendAttempt < 30000)
                    }
                  >
                    {resendEmailLoading
                      ? 'Sending...'
                      : !canResend && Date.now() - lastResendAttempt < 30000
                      ? `Resend available in ${countdown}s`
                      : 'Resend Verification Email'}
                  </button>
                </div>
              </>
            )}
          </div>
        ) : currentStep === 'business' ? (
          /* Business Step Content */
          <div className='text-center'>
            <h1 className='text-dark mb-3'>Create Business</h1>

            <div className='text-start mb-10'>
              <div className='mb-5'>
                <label className='form-label fw-bolder text-dark fs-6'>Business Name</label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  value={businessData.name}
                  onChange={handleBusinessNameChange}
                  placeholder='Enter business name'
                  disabled={hasOnboardingParams && isOnboarding && !!urlBusinessName}
                />
              </div>

              <div className='mb-5'>
                <label className='form-label fw-bolder text-dark fs-6'>Business Email</label>
                <input
                  type='email'
                  className='form-control form-control-lg form-control-solid'
                  value={businessData.email}
                  onChange={(e) => setBusinessData({...businessData, email: e.target.value})}
                  placeholder='Enter business email'
                  disabled={hasOnboardingParams && isOnboarding && !!urlBusinessEmail}
                />
              </div>

              <div className='mb-5 d-none' style={{display: 'none'}}>
                <label className='form-label fw-bolder text-dark fs-6'>Check Permission</label>
                <select
                  className='form-select form-select-lg form-select-solid'
                  value={selectedPermission}
                  onChange={handlePermissionChange}
                >
                  <option value='' disabled>
                    Select a permission
                  </option>
                  {permissionOptions.map((option: DropdownModel) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {businessCreationError && (
              <div className='mb-5 alert alert-danger'>
                <div className='alert-text font-weight-bold'>{businessCreationError}</div>
              </div>
            )}

            <button
              type='button'
              className='btn btn-sm btn-primary'
              onClick={handleCreateBusiness}
              disabled={businessLoading || !businessData.name.trim() || !businessData.email.trim()}
            >
              {businessLoading ? 'Creating...' : 'Next'}
            </button>
          </div>
        ) : currentStep === 'subscription' ? (
          /* Subscription Step Content */
          <div className='text-center'>
            {hasOnboardingParams && isOnboarding && urlSubscriptionType ? (
              <h1 className='text-dark mb-3'>Complete Your Subscription</h1>
            ) : (
              <h1 className='text-dark mb-3'>Choose Your Subscription</h1>
            )}

            {subscriptionError && (
              <div className='mb-10 alert alert-danger'>
                <div className='alert-text font-weight-bold text-dark'>{subscriptionError}</div>
              </div>
            )}

            {!showPaymentOptions &&
            !(hasOnboardingParams && isOnboarding && urlSubscriptionType) ? (
              <div className='text-start mb-10'>
                <div className='mb-5'>
                  <label className='form-label fw-bolder text-dark fs-6'>Subscription Type</label>
                  <select
                    className='form-select form-select-lg form-select-solid'
                    value={subscriptionData.subscriptionType}
                    onChange={handleSubscriptionTypeChange}
                  >
                    <option value='' disabled>
                      Select Subscription Type
                    </option>
                    <option value='STARTER'>Starter</option>
                    <option value='STANDARD'>Standard</option>
                    <option value='PREMIUM'>Premium</option>
                  </select>
                </div>

                {subscriptionData.subscriptionType && (
                  <div className='mb-5'>
                    <label className='form-label fw-bolder text-dark fs-6'>Number of Users</label>
                    <select
                      className='form-select form-select-lg form-select-solid'
                      value={subscriptionData.noOfUsers}
                      onChange={handleUserCountChange}
                    >
                      <option value=''>Select Number of Users</option>
                      {Array.apply(0, Array(20)).map((x, i) => (
                        <option key={i} value={5 * (i + 1)}>
                          {5 * (i + 1)}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {subscriptionData.subscriptionType && subscriptionData.noOfUsers && (
                  <div className='mb-5 text-center'>
                    <span className='text-gray-700 fw-bold fs-3'>
                      Price: $
                      {subscriptionData.amount - subscriptionData.discount >= 0
                        ? subscriptionData.amount - subscriptionData.discount
                        : 0}
                    </span>
                    {subscriptionData.discount > 0 && (
                      <div className='text-success fs-6'>
                        Discount: ${subscriptionData.discount}
                      </div>
                    )}
                  </div>
                )}

                <button
                  type='button'
                  className='btn btn-sm btn-primary'
                  onClick={proceedToPayment}
                  disabled={!subscriptionData.subscriptionType || !subscriptionData.noOfUsers}
                >
                  Proceed to Payment
                </button>
              </div>
            ) : (
              <div className='text-start mb-10'>
                <div className='mb-5 text-center'>
                  <h3 className='text-dark mb-3'>Payment Options</h3>
                  <div className='text-gray-600 mb-5'>
                    <strong>Subscription:</strong> {subscriptionData.subscriptionType}
                    <br />
                    <strong>Users:</strong> {subscriptionData.noOfUsers}
                    <br />
                    <strong>Amount:</strong> $
                    {subscriptionData.amount - subscriptionData.discount >= 0
                      ? subscriptionData.amount - subscriptionData.discount
                      : 0}
                  </div>
                </div>

                {subscriptionLoading ? (
                  <div className='text-center'>
                    <CircularProgress size={30} />
                    <div className='mt-3'>Processing payment...</div>
                  </div>
                ) : (
                  // <Box className='row justify-content-between align-items-center m-7'>
                  //   <div
                  //     onClick={() => submitSubscription('STRIPE')}
                  //     className='hover-pointer col-sm-4 text-center'
                  //   >
                  //     <img
                  //       alt='Stripe'
                  //       className='payment-logo'
                  //       src={toAbsoluteUrl('/media/logos/stripe_logo.png')}
                  //     />
                  //   </div>
                  //   <div
                  //     onClick={() => submitSubscription('PAYSTACK')}
                  //     className='hover-pointer col-sm-4 text-center'
                  //   >
                  //     <img
                  //       alt='Paystack'
                  //       className='payment-logo'
                  //       src={toAbsoluteUrl('/media/logos/paystack_logo.png')}
                  //     />
                  //   </div>
                  //   <div
                  //     onClick={() => submitSubscription('PAYPAL')}
                  //     className='hover-pointer col-sm-4 text-center'
                  //   >
                  //     <img
                  //       alt='PayPal'
                  //       className='payment-logo'
                  //       src={toAbsoluteUrl('/media/logos/paypal-logo-0.png')}
                  //     />
                  //   </div>
                  // </Box>
                  // Replace the payment options section with this code:

                  <Box className='row justify-content-between align-items-center m-7'>
                    <div
                      onClick={() => submitSubscription('STRIPE')}
                      className='hover-pointer col-sm-12 text-center'
                    >
                      <img
                        alt='Stripe'
                        className='payment-logo'
                        src={toAbsoluteUrl('/media/logos/stripe_logo.png')}
                      />
                    </div>
                  </Box>
                )}

                {/* {isPaypal && paypalPlanId && (
                  <Box className='d-flex justify-content-center'>
                    <Box style={{width: 300}}>
                      <PayPalSubscribeButton
                        clientId={PAYPAL_CLIENT_ID || ''}
                        planId={paypalPlanId}
                        onSuccess={onPaypalPaymentApproval}
                        onError={(err) => {
                          console.error('PayPal Error:', err)
                          setSubscriptionError('PayPal payment failed')
                        }}
                      />
                    </Box>
                  </Box>
                )} */}

                <div className='text-center mt-5'>
                  <button
                    type='button'
                    className='btn btn-sm btn-outline-primary'
                    onClick={() => {
                      setShowPaymentOptions(false)
                      setSubscriptionError('') // Clear any errors when going back
                    }}
                  >
                    Back to Subscription Details
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : null}
      </div>

      <RegistrationSuccessDialog
        open={showSuccessDialog}
        onProceedToLogin={handleProceedToLogin}
        onClose={() => setShowSuccessDialog(false)}
      />

      {/* Hidden Paystack button for auto-triggering */}
      <button
        id='initialize_paystack_payment'
        style={{display: 'none'}}
        onClick={() => {
          initializePayment()
        }}
      ></button>
      <ErrorDialog
        text={onboardingError}
        open={onboardingError}
        onConfirmDialogClose={() => {
          setOnboardingError('')
          // Redirect back to module URL
          if (moduleurl) {
            window.location.href = moduleurl
          }
        }}
      />
    </>
  )
}
